import React from 'react';
import { Outlet } from 'react-router-dom';

import Footer from './Footer';
import Header from './Header';

type PublicLayoutProps = {
  headerVariant?: 'transparent' | 'solid';
  children?: React.ReactNode;
};

function PublicLayout({ headerVariant = 'solid', children }: PublicLayoutProps) {
  return (
    <div style={{ overflowX: 'hidden' }}>
      <Header variant={headerVariant} />
      {children ?? <Outlet />}
      <Footer />
    </div>
  );
}

export default PublicLayout;
